import React, { useState } from 'react'
import './css/Scroll.css'

function Scroll() {

    const [visible, setVisible] = useState(false)

    const toggleVisible = () =>{
        const scrolled = document.documentElement.scrollTop;
        if(scrolled>300){
            setVisible(true)
        }
        else if(scrolled<=300){
            setVisible(false)
        }
    }

    const scrollToTop = () =>{
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    window.addEventListener('scroll', toggleVisible)

    return (
        <div>

            <div className="scroll-top" 
            onClick={scrollToTop}
            style={{display:visible ? 'inline' : 'none'}}
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7l4-4m0 0l4 4m-4-4v18" />
                </svg>
            </div>

        </div>
    )
}

export default Scroll